import { isCustomizedType, reduce } from "et3-type-guards";

import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";

export const apiCallGetKhattabatDashboardData = async () => {
  const { status, data, et3Error } = await post<{
    adminAlKhattabatCapacity: number;
    totalUnassignedKhattabatClients: number;
    totalUnassignedKhattabatTesters: number;
    totalUnreadMaleKhattabatMessages: number;
    totalUnreadFemaleKhattabatMessages: number;
    khattabatAdminRemuneration: number;
  }>(`dashboard/getKhattabatDashboard`, {});

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    const totalUnreadMaleKhattabatMessages = reduce(
      () => data.totalUnreadMaleKhattabatMessages,
      0
    );

    const totalUnassignedKhattabatClients = reduce(
      () => data.totalUnassignedKhattabatClients,
      0
    );

    const totalUnassignedKhattabatTesters = reduce(
      () => data.totalUnassignedKhattabatTesters,
      0
    );

    const totalUnreadFemaleKhattabatMessages = reduce(
      () => data.totalUnreadFemaleKhattabatMessages,
      0
    );

    const khattabatAdminRemuneration = reduce(
      () => data.khattabatAdminRemuneration,
      0
    );

    const adminAlKhattabatCapacity = reduce(
      () => data.adminAlKhattabatCapacity,
      0
    );

    return {
      data: {
        adminAlKhattabatCapacity,
        totalUnassignedKhattabatClients,
        totalUnassignedKhattabatTesters,
        totalUnreadMaleKhattabatMessages,
        totalUnreadFemaleKhattabatMessages,
        khattabatAdminRemuneration
      },
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);

    return {
      data: {
        adminAlkhattabatAvailibility: 0,
        adminAlKhattabatCapacity: 0,
        totalUnassignedKhattabatClients: 0,
        totalUnassignedKhattabatTesters: 0,
        totalUnreadMaleKhattabatMessages: 0,
        totalUnreadFemaleKhattabatMessages: 0,
        khattabatAdminRemuneration: 0
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        adminAlkhattabatAvailibility: 0,
        adminAlKhattabatCapacity: 0,
        totalUnassignedKhattabatClients: 0,
        totalUnassignedKhattabatTesters: 0,
        totalUnreadMaleKhattabatMessages: 0,
        totalUnreadFemaleKhattabatMessages: 0,
        khattabatAdminRemuneration: 0
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
